(function() {
  function switchSubmit(id) {
    const checkbox = document.querySelector(`#${id}`);
    const switcher = document.querySelector(`#${id}_switch`);

    if (checkbox === null || switcher === null) return;

    switcher.checked = checkbox.checked;

    switcher.addEventListener("change", function(evt) {
      checkbox.checked = evt.target.checked;
      checkbox.closest("form").submit();
    });
  }

  switchSubmit("id_enable_auto_pay");
  switchSubmit("id_announcements_emails");
  switchSubmit("id_lease_and_payment_emails");
})();
